import { createSelector } from '@ngrx/store';

import { selectECRState, State } from '@ruby/modules/ecr/store';
import * as fromECRCore from '@ruby/modules/ecr/store/reducers/ecr-core.reducer';
import * as fromECRRequests from '@ruby/modules/ecr/store/reducers/ecr-requests.reducer';
import { selectCoreState } from '@ruby/modules/ecr/store/selectors/ecr-core.selectors';

export const selectRequestsState = createSelector(
  selectECRState,
  selectCoreState,
  (state: State, coreState: { state: fromECRCore.State; route?: string }) => ({
    state: state[fromECRRequests.featureKey],
    patterns: coreState.state.patterns,
    dates: coreState.state.dates
  })
);
